import GLightbox from 'glightbox'
export default function () {
  const elements = document.querySelectorAll('.js-glightbox-modal');
  if (elements.length) {
    GLightbox({
      selector: '.js-glightbox-modal'
    });
  }
}
